// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"52e1777c","239":"74bcd816","455":"218c9a66"}[chunkId] + ".chunk.js";
};